/** Sdílené React Query klíče submodulu StationChains (napříč okny `list/` + `detail/`). */

/**
 * Klíč ListPage configu tras — zároveň prefix React Query klíčů seznamu
 * (`[STATION_CHAIN_LIST_KEY, 'list' | 'stats', …]`). Slouží k invalidaci seznamu po uložení detailu.
 */
export const STATION_CHAIN_LIST_KEY = 'products.station-chains';
